import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/',
    //     name: 'Index',
    //     component: () => import('../views/Index.vue')
    // },
    // {
    //     path: '/form',
    //     name: 'Form',
    //     component: () => import('../views/Form.vue')
    // },
    // {
    //     path: '/brain',
    //     name: 'Brain',
    //     component: () => import('../views/Brain.vue')
    // },
    // {
    //     path: '/brain2',
    //     name: 'Brain2',
    //     component: () => import('../views/Brain2.vue')
    // },
    // {
    //     path: '/brain3',
    //     name: 'Brain3',
    //     component: () => import('../views/Brain3.vue')
    // },
    // {
    //     path: '/brain4',
    //     name: 'Brain4',
    //     component: () => import('../views/Brain4.vue')
    // },
    // {
    //     path: '/paysuccess',
    //     name: 'PaySuccess',
    //     component: () => import('../views/PaySuccess.vue')
    // },
    // {
    //     path: '/confirm',
    //     name: 'Confirm',
    //     component: () => import('../views/Confirm.vue')
    // },
    {
        path: '/interview',
        name: 'Interview',
        component: () => import('../views/Interview.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/getopenid',
        name: 'GetOpenid',
        component: () => import('../views/GetOpenid.vue')
    },
    {
        path: '/improve',
        name: 'Improve',
        component: () => import('../views/Improve.vue')
    },
    // {
    //   path: '/intro',
    //   name: 'Intro',
    //   component: () => import('../views/Intro.vue')
    // },
    {
        path: '/sup',
        name: 'Sup',
        component: () => import('../views/Sup.vue')
    },
    {
        path: '/brain5',
        name: 'Brain5',
        component: () => import('../views/Brain5.vue')
    },
    {
        path: '/intro2',
        name: 'Intro2',
        component: () => import('../views/Intro2.vue')
    },
    {
        path: '/intro3',
        name: 'Intro3',
        component: () => import('../views/Intro3.vue')
    },
    {
        path: '/intro4',
        name: 'Intro4',
        component: () => import('../views/Intro4.vue')
    },
    {
        path: '/intro5',
        name: 'Intro5',
        component: () => import('../views/Intro5.vue')
    },
    {
        path: '/brain6',
        name: 'Brain6',
        component: () => import('../views/Brain6.vue')
    },
    {
        path: '/success',
        name: 'Success',
        component: () => import('../views/Success.vue')
    },
    {
        path: '/entrance',
        name: 'Entrance',
        component: () => import('../views/Entrance.vue')
    },
    {
        path: '/question',
        name: 'Question',
        component: () => import('../views/question.vue')
    },
    {
        path: '/qsuccess',
        name: 'QuestionSuccess',
        component: () => import('../views/QuestionSuccess.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
